import type { ModifierGroup } from "@workspace/model"

import { isExtrasGroup } from "@/lib/free-option-preview"

/**
 * DISPLAY order of an item's modifier groups: the item's own options (size,
 * sauces, cooking preference, …) first, extras groups last — a diner picks
 * what the item IS before they pile add-ons onto it, and the extras grid is
 * usually the longest group on the page.
 *
 * Stable within each bucket, so the backend's menu order is preserved
 * otherwise. Presentation-only: every price is summed over SELECTIONS, never
 * over render order (see the `sizeId` memo in both customizers), so reordering
 * here cannot move a total.
 */
export function orderGroupsForDisplay(
  groups: readonly ModifierGroup[]
): ModifierGroup[] {
  return displayGroupIndices(groups).map((index) => groups[index]!)
}

/**
 * {@link orderGroupsForDisplay} as POSITIONS into `groups` — for callers whose
 * state is keyed by a group's position in the item's `modifierGroups` (the
 * customizer's option selection), which must stay the menu order.
 */
export function displayGroupIndices(
  groups: readonly ModifierGroup[]
): number[] {
  const indices = groups.map((_, index) => index)
  return [
    ...indices.filter((index) => !isExtrasGroup(groups[index]!)),
    ...indices.filter((index) => isExtrasGroup(groups[index]!)),
  ]
}
